const ENDPOINT = '/api/ai/speech-to-text';

// MIME types rejected by the transcription SDK → remap to a compatible type
const MIME_REMAP: Record<string, { type: string; ext: string }> = {
  'audio/webm': { type: 'audio/ogg', ext: 'ogg' },
  'audio/webm;codecs=opus': { type: 'audio/ogg', ext: 'ogg' },
  'audio/webm; codecs=opus': { type: 'audio/ogg', ext: 'ogg' },
};

async function normalizeAudioFile(file: Blob | File): Promise<File> {
  const mimeType = (file as File).type || '';
  const remap = MIME_REMAP[mimeType] ?? (mimeType.startsWith('audio/webm') ? { type: 'audio/ogg', ext: 'ogg' } : null);

  if (remap) {
    const arrayBuffer = await file.arrayBuffer();
    const originalName = (file as File).name || 'recording';
    const baseName = originalName.replace(/\.[^.]+$/, '');
    return new File([arrayBuffer], `${baseName}.${remap.ext}`, { type: remap.type });
  }

  if (file instanceof File) return file;
  return new File([file], 'recording.ogg', { type: 'audio/ogg' });
}

export async function speechToText(
  provider: string,
  model: string,
  file: Blob | File,
  parameters: object = {}
) {
  const normalizedFile = await normalizeAudioFile(file);

  const formData = new FormData();
  formData.append('provider', provider);
  formData.append('model', model);
  formData.append('parameters', JSON.stringify(parameters));
  formData.append('file', normalizedFile);

  const response = await fetch(ENDPOINT, {
    method: 'POST',
    body: formData,
  });

  const data = await response.json();

  if (!response.ok || data.error) {
    console.error('API Route Error:', {
      error: data.error,
      details: data.details,
    });
    throw new Error(data.error || `Request failed: ${response.status}`);
  }

  return data;
}
